/**
 * 工作台相关API接口
 */
import request from './utils/request'




/**
 * 查询审批列表
 * @param {Object} params - 查询参数
 * @param {string} params.queryType - 查询类型：applicant-申请人, approver-审核人
 * @param {string} params.businessType - 业务类型枚举
 * @param {string} params.approvalStatus - 审批状态(1待审批 2已通过 3已驳回)
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} 审批列表
 */
export function getApprovalList(params) {
  return request({
    url: '/web/portal/portalSysApproval/list',
    method: 'get',
    params: params
  })
}

/**
 * 审批操作（通过/驳回）
 * @param {Object} data - 审批数据
 * @param {number} data.id - 审批记录ID
 * @param {string} data.approvalStatus - 审批状态(2已通过 3已驳回)
 * @param {string} data.remark - 备注（可选）
 * @returns {Promise} 审批结果
 */
export function approval(data) {
  return request({
    url: '/web/portal/portalSysApproval/approval',
    method: 'post',
    data: data
  })
}

/**
 * 发送审批申请
 * @param {Object} data - 审批数据
 * @param {number} data.applicantId - 申请人ID（用户或企业主体ID）
 * @param {number} data.approverId - 审批人ID（用户或企业主体ID）
 * @param {string} data.businessType - 业务类型枚举
 * @param {number} data.businessId - 关联业务ID（可选）
 * @param {string} data.remark - 备注（可选）
 * @returns {Promise} 审批结果
 */
export function sendApproval(data) {
  return request({
    url: '/web/portal/portalSysApproval/sendApproval',
    method: 'post',
    data: data
  })
}

